import { SVGProps } from 'react';

const MenuIdentityVerificationIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      data-palette="MenuIdentityVerificationIcon">
      <path
        d="M0.666748 1.3275C0.668273 1.10865 0.755832 0.899181 0.910509 0.744348C1.06519 0.589515 1.27456 0.501746 1.49341 0.5H16.5067C16.9634 0.5 17.3334 0.870833 17.3334 1.3275V14.6725C17.3319 14.8914 17.2443 15.1008 17.0897 15.2557C16.935 15.4105 16.7256 15.4983 16.5067 15.5H1.49341C1.27409 15.4998 1.06383 15.4125 0.908823 15.2573C0.753816 15.1022 0.666748 14.8918 0.666748 14.6725V1.3275ZM2.33341 2.16667V13.8333H15.6667V2.16667H2.33341ZM4.00008 3.83333H9.00008V8.83333H4.00008V3.83333ZM5.66675 5.5V7.16667H7.33341V5.5H5.66675ZM4.00008 10.5H14.0001V12.1667H4.00008V10.5ZM10.6667 3.83333H14.0001V5.5H10.6667V3.83333ZM10.6667 7.16667H14.0001V8.83333H10.6667V7.16667Z"
        fill="currentColor"
        stroke="var(--main-bg-surface)"
        strokeWidth="0.4"
      />
    </svg>)
  );
};

export default MenuIdentityVerificationIcon;
